import { Injectable } from '@angular/core';
import { BackendService } from '../backend/backend.service';

@Injectable({
  providedIn: 'root'
})

export class CandidateJobsService {


  private path = '/jobs';


  constructor(private backendService: BackendService) { }

  addAction (opt){
    return this.backendService.post (this.path, {name: opt.name, selectedBatch: opt.selectedBatch});
   }

   getLogs (id, filter){
    return  this.backendService.post (this.path  + "/" + id +  "/logs", filter);
   }
   getAllActionOptions (){
    return this.backendService.get (this.path + "/options");
  }
   getActions (filter){
    return this.backendService.post (this.path + "/find", filter);
  }

  cancelAction (id){
    return  this.backendService.get (this.path  + "/" + id +  "/cancel");
   
  }

  
  searchActions(currPage: number, pageSize: number, filter: any) {

    var data = {
      pagination: {
        page: currPage,
        size: pageSize
      },
      filter: filter
    };

    return this.backendService.post(this.path + "/search", data);
  }

}
